/* Gratis 2 ml-prøve: viser og håndterer valg af gratis prøve i kurven. */
(function () {
  function init() {
    function getRoutes() {
      var t = window.theme || {};
      var r = t.routes || {};
      return {
        cartUrl: r.cart_url || '/cart',
        cartChangeUrl: r.cart_change_url || '/cart/change.js'
      };
    }

    function debounce(fn, wait) {
      var timer;
      return function () {
        var args = arguments;
        var ctx = this;
        clearTimeout(timer);
        timer = setTimeout(function () {
          fn.apply(ctx, args);
        }, wait);
      };
    }

    function refreshFreeSamplePicker() {
      var routes = getRoutes();
      fetch(routes.cartUrl + '?section_id=api-free-sample-picker')
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var source = doc.querySelector('[data-api-free-sample]');
          document.querySelectorAll('[data-free-sample-holder]').forEach(function (holder) {
            holder.innerHTML = source ? source.innerHTML : '';
          });
        })
        .catch(function (err) {
          console.error('Free sample picker refresh failed', err);
        });
    }

    var debouncedRefresh = debounce(refreshFreeSamplePicker, 250);

    function observeCartHolders() {
      document.querySelectorAll('[data-items-holder], [data-cart-price-holder]').forEach(function (holder) {
        if (holder.dataset.freeSampleObserved) return;
        holder.dataset.freeSampleObserved = 'true';
        var observer = new MutationObserver(debouncedRefresh);
        observer.observe(holder, { childList: true, subtree: true });
      });
    }

    function removeLineItem(key) {
      var routes = getRoutes();
      return fetch(routes.cartChangeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-free-sample-btn]');
      if (!button || button.disabled) return;

      var picker = button.closest('[data-free-sample]');
      if (!picker) return;

      var currentKey = picker.getAttribute('data-current-key');
      if (!currentKey) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      button.disabled = true;

      removeLineItem(currentKey)
        .then(function () {
          picker.setAttribute('data-current-key', '');
          button.disabled = false;
          button.click();
        })
        .catch(function (err) {
          console.error('Kunne ikke skifte gratis prøve', err);
          button.disabled = false;
        });
    }, true);

    observeCartHolders();

    var bodyObserver = new MutationObserver(debounce(observeCartHolders, 300));
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
